import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { HelpCircleIcon } from 'lucide-react';
import Carousel from '../../widgets/Carousel';
import EntryForm from '../../widgets/EntryForm';
import Footer from '../../widgets/Footer';
import { useBrandConfig } from '../../../context/BrandConfigContext';

const Entry = () => {
  const brand = useBrandConfig();
  const logoSrc = brand?.logoUrl || '/assets/images/app-logo/coca-cola-white.png';
  return (
    <>
      <header className="header strict-width py-2 mx-auto">
        <div className="header-content">
          <div className="left-content">
            <img src={logoSrc} width={110} alt="App Logo" className="app-logo mt-2 ml-3" />
          </div>
          <div className="mid-content" />
          <div className="right-content d-flex align-items-center gap-3">
            <Link to="/faqs" className="text-white font-20">
              <HelpCircleIcon size={32} className="svg-primary" />
            </Link>
          </div>
        </div>
      </header>

      <main className="page-content strict-width bg-white">
        <Carousel />

        <div className="container strict-width">
          <div className="align-items-center mb-3 text-center">
            <h4 className="title">Enter Details</h4>
            <h6 className="subtitle fw-light fs-6">for a chance to win</h6>
          </div>

          <div className="text-center text-white px-0 mb-4">
            <motion.div>
              <EntryForm />
            </motion.div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default Entry;
